import { Button } from '@design/components/button/Button';
import { TooltipTrigger } from '@design/components/tooltip/Tooltip';
import { TooltipContainer } from '@terminal/components/tooltip-container/TooltipContainer';
import { useTranslation } from 'react-i18next';

import { useCopyConversation } from '../hooks/useCopyConversation';
import { ConversationTask } from '../use-chat/use-chat.types';

interface PrintPdfBtnProps {
  task: ConversationTask;
  showingSteps: boolean;
  conversationId: string;
}

export const PrintPdfBtn = ({
  task,
  showingSteps,
  conversationId,
}: PrintPdfBtnProps) => {
  const { t } = useTranslation('chat');

  const { handleCopy: handlePrintPdf } = useCopyConversation({
    task,
    questionOnly: false,
    showingSteps,
    conversationId,
    action: 'print',
  });

  return (
    <TooltipContainer
      label={t('chat:printPdf')}
      inPortal
      trigger={[TooltipTrigger.Hover]}
    >
      <Button
        data-testid="button-print-pdf"
        variant="empty"
        size="xsmall"
        iconName="Print"
        onClick={handlePrintPdf}
      />
    </TooltipContainer>
  );
};
